import { Components, Theme } from '@mui/material';

const MuiDialog: Components<Theme>['MuiDialog'] = {
  styleOverrides: {
    root: {
      zIndex: 4000,
    },
  },
};

export default MuiDialog;
